import type { TaskMenuTarget } from '../components/TaskMenu/TaskMenu.types'

/** Je Marke, ob ihr Kasten einen Entfernen-Weg zeigt. */
export type RemovableMarkers = Partial<Record<Exclude<TaskMenuTarget, 'move'>, boolean>>

/** Strukturell wie `TaskMenuMarkSource`: Die Felder tragen `Task` und `TaskEntryData` in leicht verschiedenen Typen. */
interface MarkerFields {
  startDate?: unknown
  dueDate?: unknown
  estimatedDuration?: unknown
  attention?: unknown
  tags?: readonly unknown[] | null
  rewardId?: unknown
  recurrence?: unknown
}

/**
 * **Was sich in der Mehrfachauswahl entfernen lässt** (#313, Sven 10.10.2026): eine Marke, sobald MINDESTENS
 * EINE der Aufgaben sie trägt. Die Kästen der Pille zeigen die Werte der obersten Aufgabe — trägt die keine,
 * fehlte sonst der Weg, die Marke der übrigen loszuwerden.
 */
export function removableMarkers(tasks: readonly MarkerFields[]): Required<RemovableMarkers> {
  return {
    start: tasks.some(task => task.startDate != null),
    deadline: tasks.some(task => task.dueDate != null),
    // Wie der Kasten selbst (`durationValue`): 0 Minuten ist keine Dauer.
    duration: tasks.some(task => !!task.estimatedDuration),
    attention: tasks.some(task => task.attention != null),
    tags: tasks.some(task => (task.tags ?? []).length > 0),
    reward: tasks.some(task => task.rewardId != null),
    recurrence: tasks.some(task => task.recurrence != null),
  }
}
